// Dashboard Actions

export const GET_DASHBOARD_AUDITS =
    "[Dashboard] Get audits";

export const GET_DASHBOARD_AUDITS_SUCCESS =
    "[Dashboard] Get audits success";

export const GET_DASHBOARD_AUDITS_ERROR =
    "[Dashboard] Get audits error";


export const GET_DASHBOARD_ISSUES =
    "[Dashboard] Get issues";

export const GET_DASHBOARD_ISSUES_SUCCESS =
    "[Dashboard] Get issues success";

export const GET_DASHBOARD_ISSUES_ERROR =
    "[Dashboard] Get issues error";


export const GET_DASHBOARD_ALERTS =
    "[Dashboard] Get alerts";

export const GET_DASHBOARD_ALERTS_SUCCESS =
    "[Dashboard] Get alerts success";

export const GET_DASHBOARD_ALERTS_ERROR =
    "[Dashboard] Get alerts error";


export const SET_DASHBOARD_AUDITS =
    "[Dashboard] Set audits";

export const SET_DASHBOARD_ISSUES =
    "[Dashboard] Set issues";

export const SET_DASHBOARD_ALERTS =
    "[Dashboard] Set alerts";



/* =========================
   AUDITS
========================= */

export const getDashboardAudits = (data) => ({
    type: GET_DASHBOARD_AUDITS,
    payload: data
});

export const getDashboardAuditsSuccess = (data) => ({
    type: GET_DASHBOARD_AUDITS_SUCCESS,
    payload: data
});

export const getDashboardAuditsError = (data) => ({
    type: GET_DASHBOARD_AUDITS_ERROR,
    payload: data
});

export const setDashboardAudits = (data) => ({
    type: SET_DASHBOARD_AUDITS,
    payload: data
});



/* =========================
   ISSUES
========================= */

export const getDashboardIssues = (data) => ({
    type: GET_DASHBOARD_ISSUES,
    payload: data
});

export const getDashboardIssuesSuccess = (data) => ({
    type: GET_DASHBOARD_ISSUES_SUCCESS,
    payload: data
});

export const getDashboardIssuesError = (data) => ({
    type: GET_DASHBOARD_ISSUES_ERROR,
    payload: data
});

export const setDashboardIssues = (data) => ({
    type: SET_DASHBOARD_ISSUES,
    payload: data
});



/* =========================
   ALERTS
========================= */

export const getDashboardAlerts = (data) => ({
    type: GET_DASHBOARD_ALERTS,
    payload: data
});

export const getDashboardAlertsSuccess = (data) => ({
    type: GET_DASHBOARD_ALERTS_SUCCESS,
    payload: data
});

export const getDashboardAlertsError = (data) => ({
    type: GET_DASHBOARD_ALERTS_ERROR,
    payload: data
});

export const setDashboardAlerts = (data) => ({
    type: SET_DASHBOARD_ALERTS,
    payload: data
});

